import React from 'react';
import ReactDOM from 'react-dom';

const filterItem = (item, term) => {
    if (!term.length) {
        return true;
    }
    // revisit
    return item.post_title.toLowerCase().indexOf(term.toLowerCase()) > -1;
};

const sortItems = (a, b, prop, sortAscending) => {
    if (a[prop] === b[prop]) {
        return 0;
    }
    let sort;
    switch (prop) {
        case 'price':
            console.log(parseFloat(a[prop]), parseFloat(b[prop]));
            sort = parseFloat(a[prop]) > parseFloat(b[prop]) ? 1 : -1;
            break;
        default:
            sort = a[prop] > b[prop] ? 1 : -1;
            break;
    }
    return sortAscending ? sort : (sort * -1);
};

const sortAndFilterItems = (items, searchTerm, sortColumn, sortAscending) => {
    return items
        .filter(item => filterItem(item, searchTerm))
        .sort((a, b) => sortItems(a, b, sortColumn, sortAscending));
};

const getKeyValue = (item, key) => {
    switch (key) {
        // boolean
        case 'available':
            return item[key] ? 'Yes' : 'No';
        case 'lead_time':
            return item[key] + ' weeks';
        case 'price':
            return '$' + parseFloat(item[key]).toFixed(2);
        default:
            return item[key];
    }
};


/**
 * React Part Catalog - Sortable Table
 * @see https://reactjs.org/docs/components-and-props.html
 * @param props 
 */
const ReactPartCatalog = (props) => {

    // console.log('Props', props);

    const columnMap = {
        post_title: 'Product',
        application: 'Application',
        comments: 'Comments',
        description: 'Description',
        lead_time: 'Lead Time',
        nomenclature: 'Name',
        part_number: 'Part #',
        price: 'Price',
        priority: 'Priority',
        quantity: 'Quantity'
    };

    const useColumns = [
        'part_number', 'nomenclature', 'price', 'lead_time', 'quantity'
    ];

    const searchInput = React.useRef(null);

    const [searchTerm, setSearchTerm] = React.useState('');
    const [sortColumn, setSortColumn] = React.useState('post_title');
    const [sortAscending, setSortAscending] = React.useState(true);
    
    const CatalogItem = (props) => (
        // <a href={props.item.link} className="part-catalog-item row">
        //     {useColumns.map((key, index) => (
        //         <span key={key} className={'col part-catalog-item--' + key}>{getKeyValue(props.item, key)}</span>
        //     ))}
        // </a>
        <tr className="part-catalog-item text-capitalize">
            <td class="d-none">{/** image here, use `props.item.thumbnail.src` */}</td>
            {useColumns.map((key, index) => (
                <td key={key} className={'part-catalog-item--' + key}>
                    {key === 'nomenclature' && <a className="text-cts" href={props.item.link}>{getKeyValue(props.item, key)}</a>}
                    {key !== 'nomenclature' && getKeyValue(props.item, key)}
                </td>
            ))}
        </tr>
    );

    const CatalogItems = (props) => (
        <tbody className="part-catalog--items">{props.children}</tbody>
    );

    const handleColumnClick = (key) => {
        if (sortColumn === key) {
            setSortAscending(!sortAscending);
        } else {
            setSortColumn(key);
            setSortAscending(true);
        }
        // updateUseItems();
    };

    const handleSearchTermChange = (event) => {
        setSearchTerm(event.target.value);
        // updateUseItems();
    };

    const handleResetClick = (event) => {
        setSearchTerm('');
        searchInput.current.value = '';
    };
    
    const sortedAndFilteredItems = sortAndFilterItems([...props.items], searchTerm, sortColumn, sortAscending);

    return (
        <section className="part-catalog">
            <header className="part-catalog--header container-fluid px-1 px-lg-5 py-1 py-lg-3">
                <div className="form-group mb-0">
                    <label className="sr-only" htmlFor="searchTerm">Filter parts list</label>
                    <div className="input-group">
                        <input 
                            type="text" 
                            name="searchTerm" 
                            className="form-control form-control-lg" 
                            placeholder="Search..."
                            ref={searchInput} 
                            onChange={(event) => handleSearchTermChange(event)}
                        />
                        <div className="input-group-append">
                            <button onClick={(event) => handleResetClick(event)} className="btn btn-dark btn-sm px-4 py-1">Reset</button>
                        </div>
                    </div>
                    {/** 
                    <p>Term: {searchTerm}</p>
                    <p>Sort: {sortColumn}</p>
                    <p>Ascending: {sortAscending ? 'true' : 'false'}</p>
                    */}
                </div>
            </header>
            <table className="part-catalog--table table table-striped">
                <thead className="part-catalog--columns">
                    <tr>
                    <th class="d-none">{/** image here */}</th>
                    {useColumns.map(key => (
                        <th key={key} className={'part-catalog--column part-catalog--column-' + key}>
                            <button
                                className="part-catalog--column-button"
                                onClick={(event) => handleColumnClick(key)}
                            >
                                {columnMap[key]} <i className={'fas fa-sort' + (sortColumn === key ? (sortAscending ? '-up' : '-down') : '') }></i>
                            </button>
                        </th>
                    ))}
                    </tr>
                </thead>
                <CatalogItems>
                    {sortedAndFilteredItems.map(item => (
                        <CatalogItem key={item.ID} item={item}/>
                    ))}
                    {!sortedAndFilteredItems.length && 
                        <tr><td colSpan={useColumns.length} className="text-center">No results</td></tr>
                    }
                </CatalogItems>
            </table>
        </section>
    );
    
}

const reactPartCatalogElements = Array.from(
	document.querySelectorAll('[data-react-component="ReactPartCatalog"]')
);
if (reactPartCatalogElements.length) {
	reactPartCatalogElements.forEach(el => {
		if (el.dataset.reactProps) {
            const props = JSON.parse(el.dataset.reactProps);
            ReactDOM.render(<ReactPartCatalog {...props} />, el);
		} else {
			console.log('Missing required props');
		}
	});
}
